// NATIVE
import * as React from 'react';

// INSTALLED
import { Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// CUSTOM
import { SnackAlert } from '../../SnackAlert';
import { useDispatch, useSelector } from 'react-redux';
import { MessagesDrawerRight } from '../../MessagesDrawerRight';
import { EditCargo } from '../../cargos/editar/EditCargo';
import editCargoFormModel from '../../cargos/formModels/editar/editCargoFormModel';
import validationSchema from '../../cargos/formModels/editar/validationSchema';
import formInitialValues from '../../cargos/formModels/editar/formInitialValues';
import { storeEditCargo } from '../../../store/cargos';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const EditDialogTurno = (props: any) => {
  // const [open, setOpen] = React.useState(false);

  const { open, handleCloseModalEditarCargo, buttons = false } = props;

  const dispatch = useDispatch();

  const { formId, formField } = editCargoFormModel;

  const currentValidationSchema = validationSchema[0];

  const [percentaje_area, setPercentajeArea] = React.useState(0);
  const [data, setMsgErrors] = React.useState([]);
  const [alert_snack, setAlertSnack] = React.useState(false);

  const handleClose = () => {
    handleCloseModalEditarCargo(false);
  };

  const _handleSubmit = async (values: any, actions: any) => {
    actions.setSubmitting(true);

    const response = await dispatch(storeEditCargo(values));

    if (!response.ok) {
      if (
        response.errors &&
        response.errors.message.constructor === Array &&
        response.errors.message.length > 0
      ) {
        setMsgErrors(response.errors.message);
        return false;
      }
    }

    if (response.ok) {
      setAlertSnack(true);
    }

    actions.resetForm();
    actions.setSubmitting(false);
    handleCloseModalEditarCargo(false);
  };

  return (
    <React.Fragment>
      <MessagesDrawerRight data={data} title={''} />

      <SnackAlert
        open={alert_snack}
        onclick={setAlertSnack}
        text={'Cargo editado con exito'}
        severity={'success'}
      />

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Editar Cargo
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid>
            <Formik
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}
            >
              <>
                <Form id={formId}>
                  <EditCargo formField={formField} />

                  <Button
                    // disabled={isSubmitting}
                    style={{ margin: 5, float: 'right' }}
                    type="submit"
                    variant="contained"
                    color={'primary'}
                  >
                    Editar Area
                  </Button>
                </Form>
              </>
            </Formik>
          </Grid>
        </DialogContent>
        <DialogActions></DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};
